const getPatientState = ({ patient, value, billing = false }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const address = billing ? patient['Billing Address Information'] : patient['Address Information'];
  if (address && address.State) {
    return address.State.toUpperCase();
  }
  return null;
};

export default getPatientState;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientState.js